module.exports = __webpack_public_path__ + "img/1.e48dea49.png";